import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "inviteBulkLoad" }
const _hoisted_2 = { id: "MainInviteBulkLoad" }
const _hoisted_3 = {
  key: 0,
  class: "alertBox"
}
const _hoisted_4 = { class: "pagePanel" }
const _hoisted_5 = { class: "pagePanel batchParams" }
const _hoisted_6 = { class: "paramGrid" }
const _hoisted_7 = { class: "section" }
const _hoisted_8 = { class: "section" }
const _hoisted_9 = { class: "section" }
const _hoisted_10 = { class: "section" }
const _hoisted_11 = { class: "section" }
const _hoisted_12 = { class: "section" }
const _hoisted_13 = { class: "section" }
const _hoisted_14 = { class: "section" }
const _hoisted_15 = { class: "pagePanel invitesPanel" }
const _hoisted_16 = { class: "invitesHeader" }
const _hoisted_17 = { class: "invitesActions" }
const _hoisted_18 = {
  key: 0,
  class: "infoBox",
  role: "status"
}
const _hoisted_19 = {
  id: "submitSection",
  class: "submitSection"
}
const _hoisted_20 = { class: "submitActions" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "error submitHint"
}
const _hoisted_23 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CwePageHeader = _resolveComponent("CwePageHeader")!
  const _component_InviteCsvUpload = _resolveComponent("InviteCsvUpload")!
  const _component_vue_multiselect = _resolveComponent("vue-multiselect")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_InviteBulkGrid = _resolveComponent("InviteBulkGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CwePageHeader, { authenticationRequired: true }),
    _createElementVNode("div", _hoisted_2, [
      _cache[24] || (_cache[24] = _createElementVNode("h5", { class: "sectionHeader" }, "Invite Bulk Load", -1)),
      _cache[25] || (_cache[25] = _createElementVNode("p", { class: "intro" }, " Upload a CSV of invites, review and correct the rows below, then import. Saved rows stay here marked Created or Updated; rows that fail to save show the reason so you can fix and import them again. ", -1)),
      (_ctx.pageError)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.pageError), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createBlock(_component_InviteCsvUpload, {
          key: _ctx.uploadKey,
          onFileSelected: _ctx.onFileSelected,
          onParsed: _ctx.onParsed,
          onBatchError: _ctx.onBatchError
        }, null, 8, ["onFileSelected", "onParsed", "onBatchError"]))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[20] || (_cache[20] = _createElementVNode("h6", { class: "subHeader" }, "Applied to every invite", -1)),
        _cache[21] || (_cache[21] = _createElementVNode("p", { class: "batchHint" }, " These values are copied into each invite row below. Every invite is created for the selected Source App. ", -1)),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "label-bold" }, [
              _createElementVNode("label", { for: "sourceApp" }, "Source App")
            ], -1)),
            _createVNode(_component_vue_multiselect, {
              id: "sourceApp",
              modelValue: _ctx.selectedApplication,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedApplication) = $event)),
              options: _ctx.applications,
              "track-by": "key",
              label: "name",
              "show-labels": false,
              placeholder: "Select a source app"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "label-bold" }, [
              _createElementVNode("label", { for: "country" }, "Country")
            ], -1)),
            _createVNode(_component_vue_multiselect, {
              id: "country",
              modelValue: _ctx.selectedCountry,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedCountry) = $event)),
              options: _ctx.countries,
              "track-by": "abbreviation",
              label: "name",
              "show-labels": false,
              placeholder: "Select a country"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "label-bold" }, [
              _createElementVNode("label", { for: "language" }, "Language")
            ], -1)),
            _createVNode(_component_vue_multiselect, {
              id: "language",
              modelValue: _ctx.selectedLanguage,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedLanguage) = $event)),
              options: _ctx.languages,
              "track-by": "code",
              label: "label",
              "show-labels": false,
              placeholder: "Select a language"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "label-bold" }, [
              _createElementVNode("label", { for: "accountType" }, "Application account type")
            ], -1)),
            _createVNode(_component_vue_multiselect, {
              id: "accountType",
              modelValue: _ctx.selectedAccountType,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedAccountType) = $event)),
              options: _ctx.accountTypes,
              "track-by": "name",
              label: "name",
              "show-labels": false,
              placeholder: "Select an application account type"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "label-bold" }, [
              _createElementVNode("label", { for: "userAccountType" }, "User account type")
            ], -1)),
            _createVNode(_component_vue_multiselect, {
              id: "userAccountType",
              modelValue: _ctx.selectedUserAccountType,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedUserAccountType) = $event)),
              options: _ctx.userAccountTypes,
              "track-by": "name",
              label: "name",
              "show-labels": false,
              placeholder: "Select a user account type"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "label-bold" }, [
              _createElementVNode("label", { for: "name" }, "Account name")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              id: "name",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.name) = $event)),
              type: "text"
            }, null, 512), [
              [_vModelText, _ctx.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "label-bold" }, [
              _createElementVNode("label", { for: "externalId" }, "External ID")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              id: "externalId",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.externalId) = $event)),
              type: "text"
            }, null, 512), [
              [_vModelText, _ctx.externalId]
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "label-bold" }, [
              _createElementVNode("label", { for: "authPathSegment" }, "Auth path segment")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              id: "authPathSegment",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.authPathSegment) = $event)),
              type: "text"
            }, null, 512), [
              [_vModelText, _ctx.authPathSegment]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _cache[23] || (_cache[23] = _createElementVNode("h5", { class: "invitesHeading" }, "Invites", -1)),
          _createElementVNode("div", _hoisted_17, [
            (_ctx.rows.length > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "exportBtn",
                  title: "Export CSV",
                  "aria-label": "Export CSV",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onExport && _ctx.onExport(...args)))
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-file-export" })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "addInviteBtn",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onAddRow && _ctx.onAddRow(...args)))
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-plus" }),
              _cache[22] || (_cache[22] = _createTextVNode(" Invite ", -1))
            ])
          ])
        ]),
        (_ctx.submitSummary)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createVNode(_component_font_awesome_icon, {
                icon: "fa-solid fa-circle-info",
                class: "infoIcon"
              }),
              _createElementVNode("span", null, [
                _createTextVNode(" Processed " + _toDisplayString(_ctx.submitSummary.processed) + ": " + _toDisplayString(_ctx.submitSummary.created) + " created, " + _toDisplayString(_ctx.submitSummary.updated) + " updated, " + _toDisplayString(_ctx.submitSummary.failed) + " failed. ", 1),
                (_ctx.submitSummary.failed > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" Rows that failed show the reason in red in the Status column — fix them and import again. ")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("All invites saved successfully.")
                    ], 64))
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_InviteBulkGrid, {
          rows: _ctx.rows,
          cellErrors: _ctx.cellErrors,
          rowErrors: _ctx.submitRowErrors,
          rowStatuses: _ctx.rowStatuses,
          applications: _ctx.applications,
          onCellChange: _ctx.onCellChange,
          onDeleteRow: _ctx.onDeleteRow
        }, null, 8, ["rows", "cellErrors", "rowErrors", "rowStatuses", "applications", "onCellChange", "onDeleteRow"]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              type: "button",
              class: "resetBtn",
              disabled: _ctx.submitting,
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onReset && _ctx.onReset(...args)))
            }, " Reset ", 8, _hoisted_21),
            (_ctx.submitBlockedReason)
              ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(_ctx.submitBlockedReason), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "importBtn",
              disabled: !_ctx.canSubmit,
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
            }, " Import ", 8, _hoisted_23)
          ])
        ])
      ])
    ])
  ]))
}